export var strawberry = {
  start: '#fc6e51',
  end: '#da4453',
  deg: 90
};
export var peach = {
  start: '#fc6e51',
  end: '#f6bb42',
  deg: 90
};
export var pear = {
  start: '#ffce54',
  end: '#8cc152',
  deg: 90
};
export var kiwi = {
  start: '#a0d468',
  end: '#37bc9b',
  deg: 90
};
export var sea = {
  start: '#48cfad',
  end: '#3bafda',
  deg: 90
};
export var coursera = {
  start: '#4fc1e9',
  end: '#4a89dc',
  deg: 90
};
export var blueberry = {
  start: '#5d9cec',
  end: '#967adc',
  deg: 90
};
export var grape = {
  start: '#ac92ec',
  end: '#d770ad',
  deg: 90
};
export var productCardSpecialization = {
  start: '#2965CA',
  end: '#563BC2',
  deg: 135
};